import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

export const SEOHead = () => {
    const location = useLocation();
    const { language } = useLanguage();

    useEffect(() => {
        const path = location.pathname;
        let title = 'Triyo - The Ultimate Student Study Desk';

        // Map paths to titles
        switch (path) {
            case '/':
                title = language === 'ar' 
                    ? 'Triyo - مكتبك الدراسي المتكامل'
                    : 'Triyo - The Ultimate Student Study Desk';
                break;
            case '/login':
                title = language === 'ar' 
                    ? 'تسجيل الدخول - Triyo'
                    : 'Login - Triyo';
                break;
            case '/dashboard':
                title = language === 'ar' 
                    ? 'لوحة التحكم - Triyo'
                    : 'Dashboard - Triyo';
                break;
            case '/weekly-plan':
                title = language === 'ar' 
                    ? 'الخطة الأسبوعية - Triyo'
                    : 'Weekly Plan - Triyo';
                break;
            case '/analytics':
                title = language === 'ar' 
                    ? 'التحليلات - Triyo'
                    : 'Analytics - Triyo';
                break;
            case '/grades':
                title = language === 'ar' 
                    ? 'درجاتي - Triyo'
                    : 'My Grades - Triyo';
                break;    
            default:
                // Keep default
                break;
        }

        document.title = title;
        
    }, [location, language]);

    return null; // This component doesn't render anything visual
};
